import { useSelector } from 'react-redux'

import { selectUser } from '@/store/slices/authSlice'
import { UserProfile } from '@/types/layout'

/**
 * Hook to get user profile data for the layout
 * Adapts Redux auth state to UserProfile interface
 */
export const useUserProfile = (): UserProfile => {
  const user = useSelector(selectUser)

  // Return mock user if not authenticated (for development)
  if (!user) {
    return {
      id: 'admin',
      name: 'Admin',
      email: 'admin@example.com',
      role: 'Admin',
    }
  }

  // Map Redux user to UserProfile
  return {
    id: user.id,
    name: user.fullName || user.username,
    email: user.email,
    avatar: user.avatar,
    role: user.roles.length > 0 ? user.roles[0] : undefined,
  }
}
